//Global imports
import { cilExternalLink, cilPencil } from '@coreui/icons';
import CIcon from '@coreui/icons-react';
import {
    CButton,
    CCard,
    CCardBody,
    CCardFooter,
    CCardHeader,
    CCardText,
    CCardTitle,
    CCol,
    CLink,
} from '@coreui/react';

//File imports
import { Language } from '../../../../language/English';
import { DraftPojo } from '../../Api/DraftPojo';
import {
    APP_LANGAUGE,
    LANGAUGE_NAME,
    LANGUAGE_ID_ENGLISH,
    LANGUAGE_ID_FRENCH,
    LANGUAGE_ID_GERMAN,
    ROUT_PAGE_NAME_UPDATE_DOCUMENT_DE,
    ROUT_PAGE_NAME_UPDATE_DOCUMENT_EN,
    ROUT_PAGE_NAME_UPDATE_DOCUMENT_FR,
    WEBSITE_BASE_URL,
} from '../../../../Constant';
import DateUtility from '../../../../services/DateUtils/DateUtils';
import { UtmParametersModal } from '../../../../components';
import { useState } from 'react';

const DraftCard = (props: { draft: DraftPojo; key: number }) => {
    const data = props.draft;
    let metaInfo = data?.metaInfo ?? '{}';
    let isUtmAvailable =
        JSON.parse(metaInfo)?.utm &&
        Object.keys(JSON.parse(metaInfo)?.utm).length > 0;
    const dateUtils = new DateUtility();

    const [utmModalVisible, setUtmModalVisible] = useState(false);

    const getLangaugeBasedOnLangaugeId = (langaugeId: number): string => {
        const langKey = Object.keys(APP_LANGAUGE).find(
            (key) => APP_LANGAUGE[key] === langaugeId,
        );

        return langKey ? LANGAUGE_NAME[langKey] : '';
    };

    const getRedirectPageName = (langaugeId: number): string => {
        if (langaugeId === LANGUAGE_ID_ENGLISH) {
            return ROUT_PAGE_NAME_UPDATE_DOCUMENT_EN;
        } else if (langaugeId === LANGUAGE_ID_GERMAN) {
            return ROUT_PAGE_NAME_UPDATE_DOCUMENT_DE;
        } else if (langaugeId === LANGUAGE_ID_FRENCH) {
            return ROUT_PAGE_NAME_UPDATE_DOCUMENT_FR;
        }
        return '';
    };

    let redirectUrl = getRedirectPageName(data?.translation?.languageId);

    return (
        <CCol xs={12} md={4} className="mb-4">
            <CCard className="border-0 shadow-sm rounded-2">
                <CCardBody>
                    <div className="d-flex justify-content-between align-items-start">
                        <CCardTitle
                            className="fs-3 text-truncate"
                            style={{ maxWidth: '100%' }}
                        >
                            {data?.translation?.title}
                        </CCardTitle>
                    </div>
                    <div className="d-flex justify-content-between fst-italic">
                        {dateUtils.formatUnixTimestampToDateString(
                            data?.createdOn,
                        )}
                    </div>
                    <div className="d-flex justify-content-between">
                        <CCardText className="mb-0">
                            {Language.LANGAUGE}:{' '}
                            <span className="fw-bold">
                                {getLangaugeBasedOnLangaugeId(
                                    data?.translation?.languageId,
                                )}
                            </span>
                        </CCardText>
                        <CCardText className="mb-0">
                            {Language.PRICE}:{' '}
                            <span className="fw-bold">
                                {data?.template?.price}
                            </span>
                        </CCardText>
                    </div>

                    {JSON.parse(metaInfo)?.referer && (
                        <div className="d-flex justify-content-between mt-1">
                            <CCardText className="mb-0 text-break">
                                {Language.REFERRER}:{' '}
                                <span className="fw-bold">
                                    {JSON.parse(metaInfo)?.referer}
                                </span>
                            </CCardText>
                        </div>
                    )}

                    <div className="d-flex justify-content-between mt-1">
                        <CCardText className="mb-0">
                            {Language.GOOGLE_ADS}:{' '}
                            <span className="fw-bold">
                                {isUtmAvailable ? Language.YES : Language.NO}
                            </span>
                            {isUtmAvailable && (
                                <CLink
                                    href="#"
                                    className="link-primary small text-decoration-underline mx-1"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setUtmModalVisible(true);
                                    }}
                                >
                                    {Language.VIEW}
                                </CLink>
                            )}
                        </CCardText>
                    </div>

                    <CCardText className="fw-bold mt-1 mb-1">
                        {Language.CUSTOMER}
                    </CCardText>
                    <hr className="my-2" />

                    {data?.customer?.name && (
                        <CCardText className="mb-0">
                            <span>{data?.customer?.name}</span>
                        </CCardText>
                    )}

                    {data?.customer?.email && (
                        <CCardText className="mb-0">
                            <span>{data?.customer?.email}</span>
                        </CCardText>
                    )}

                    {data?.customer?.phoneNumber && (
                        <CCardText className="mb-0">
                            <span>{data?.customer?.phoneNumber}</span>
                        </CCardText>
                    )}
                </CCardBody>
                <CCardFooter className="bg-white">
                    <div className="d-flex gap-2">
                        <CButton
                            color="primary"
                            size="sm"
                            onClick={() =>
                                window.open(
                                    `${WEBSITE_BASE_URL}/${redirectUrl}/${data?.uniqueId}`,
                                    '_blank',
                                )
                            }
                        >
                            <CIcon icon={cilExternalLink} className="me-2" />
                            {Language.SEE_DOCUMENT}
                        </CButton>
                    </div>
                </CCardFooter>
            </CCard>

            <UtmParametersModal
                visible={utmModalVisible}
                onClose={() => setUtmModalVisible(false)}
                utmParams={JSON.parse(metaInfo)?.utm ?? {}}
            />
        </CCol>
    );
};

export default DraftCard;
